<template>
  <div class="admin-notifications-container">
    <div class="header">
      Notificaciones
    </div>
    <div class="notification-card">
      <div class="card-header">
        Notificación masiva
      </div>
      <div class="label">
        <div class="label-text">Contenido:</div>
        <BaseInput v-model="data.content"/>
      </div>
      <div class="label label--half">
        <div class="label-text">URL de redirección:</div>
        <BaseInput v-model="data.url"/>
      </div>
      <div class="button-wrapper">
        <div class="button" @click="sendNotification">
          Enviar
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import BaseInput from '@/components/base/BaseInput.vue';

export default {
  data() {
    return {
      data: {
        content: '',
        url: '',
      },
    };
  },
  components: {
    BaseInput,
  },
  methods: {
    async sendNotification() {
      await axios.post(`${process.env.VUE_APP_SERVER_URL}/notifications/create`, this.data);
      this.data = {
        content: '',
        url: '',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-notifications-container {
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.header {
  font-size: 28px;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.notification-card {
  border: 1px solid #e8e8e8;
  background-color: white;
  padding: 20px;
  border-radius: 6px;
  margin-top: 24px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.card-header {
  font-weight: 500;
  width: 100%;
}
.label {
  width: 100%;
  margin-top: 16px;
}
.label--half {
  width: 50%;
}
.label-text {
  margin-bottom: 10px;
}
.button-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.button {
  background-color: #3479e9;
  color: white;
  padding: 12px 0;
  display: flex;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  width: 120px;
}
</style>
